<template>
    <checkout-step>
        <template slot="title">
            <span @click="currentStep > 1 ? $parent.$parent.jumpTo(1) : null">{{ __('Bejelentkezés') }}</span>
        </template>

        <div class="my-align-content-center my-align-self-center">
            <portal-target
                v-if="portalAvailable"
                name="checkout-authentication-before"
            />

            <div class="form-group row group-row">
                <label
                    for="email"
                    class="col-md-4 col-form-label text-md-right"
                >
                    {{ __('E-mail cím') }}
                </label>

                <div class="col-md-6">
                    <input
                        id="email"
                        v-model="email"
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.email }"
                        required
                        autocomplete="email"
                    >

                    <span
                        v-if="errors.email"
                        class="invalid-feedback"
                        role="alert"
                    >
                        <strong v-for="message in errors.email">{{ message }}</strong>
                    </span>
                </div>
            </div>

            <div class="form-group row group-row">
                <label
                    for="password"
                    class="col-md-4 col-form-label text-md-right"
                >{{ __('Jelszó') }}</label>

                <div class="col-md-6">
                    <input
                        id="password"
                        v-model="password"
                        type="password"
                        class="form-control"
                        :class="{ 'is-invalid': errors.password }"
                        required
                        autocomplete="current-password"
                    >

                    <span
                        v-if="errors.password"
                        class="invalid-feedback"
                        role="alert"
                    >
                        <strong v-for="message in errors.password">{{ message }}</strong>
                    </span>
                </div>
            </div>


            <div class="form-group row mb-0 group-row">
                <div class="col-md-8 offset-md-4">
                    <button
                        class="btn btn-primary cart-continue"
                        style="float:left;"
                        @click="login"
                    >
                        {{ __('Bejelentkezés') }}
                    </button>
                    <a
                        v-if="route().check('password.request')"
                        class="btn btn-link"
                        :href="route('password.request')"
                    >
                        {{ __('Forgot Your Password?') }}
                    </a>
                </div>
            </div>
        </div>

        <portal-target
            v-if="portalAvailable"
            name="checkout-customer-data-after"
        />

        <template
            slot="navigation"
            slot-scope="{ prev, next }"
        >
            <button
                v-if="currentStep !== 1"
                type="button"
                class="btn btn-danger btn-back cart-continue"
                style="float:left;"
                @click="prev()"
            >
                {{ __('Vissza') }}
            </button>
            <button
                class="btn btn-secondary float-right group-row cart-continue"
                @click="continueWithoutLogin()"
            >
                {{ __('Folytatás bejelentkezés nélkül') }}
            </button>
        </template>
    </checkout-step>
</template>

<script>
import authenticationBase from '../../../mixins/checkout/authenticationBase'

export default {
    name: 'Authentication',
    mixins: [authenticationBase],

    methods: {
        continueWithoutLogin() {
            let _coupons = this.$store.state.cart.discounts.filter(item => typeof item.code !== undefined)
            let _coupon = ''
            if ( _coupons.length ) {
                _coupon = _coupons[0].code
            }

            const payload = {
                items: this.$store.state.cart.items.map(
                    item => {
                        return {
                            id: item.id.identifier,
                            name: item.name,
                            quantity: item.quantity,
                            price: item.price.gross
                        }
                    }
                ),
                'coupon': _coupon,
                'checkout_step': 1,
                'checkout_option': 'shop without logging in'
            }

            gtag('event', 'checkout_progress', payload)

            this.$bus.$emit('checkout-step-next')
        }
    }
}
</script>

